<template>
<div>
  <newWhitelist>

</newWhitelist>


  

      <el-table
    :data="tableData"
    stripe
    style="width: 100%;white-space:pre-wrap"
    height="750"
    :default-sort="{prop: 'id', order: 'descending'}">
    <el-table-column
      prop="id"
      label="编号"
      width="80"  sortable>
    </el-table-column>

    <el-table-column   prop="device_number" label="device_number">
    </el-table-column>


    <el-table-column
      prop="date"
      label="加入白名单的日期"  width="200" >
    </el-table-column>

    <el-table-column   prop="des" label="描述"   >
    </el-table-column>
    <el-table-column   prop="author" label="操作者"   >
    </el-table-column>
    <el-table-column   prop="update_time" label="修改日期"   >
    </el-table-column>
    <el-table-column
      fixed="right"
      label="操作"
      width="100">
      <template slot-scope="scope">
        <el-button @click="handleClick(scope.row)" type="text" size="small">删除</el-button>
        
      </template>
    </el-table-column>



  </el-table>



  
    </div>
  </template>
  
  <script>

import newWhitelist from './newWhitelist.vue'; 


export default {
  components: {
    
    newWhitelist
},

methods: {

  handleClick(row) {
  this.numberA = Math.floor(Math.random() * 100); // 生成0到99之间的随机整数作为数字A
  this.numberB = Math.floor(Math.random() * 100); // 生成0到99之间的随机整数作为数字B

  this.$prompt(
    `请输入数字${this.numberA}和数字${this.numberB}的和`,
    "请仔细确认后再进行删除",
    {
      inputPattern: /^\d+$/,
      inputErrorMessage: "请输入有效的数字",
    }
  )
    .then(({ value }) => {
      const result = parseInt(value);
      if (result === this.numberA + this.numberB) {
        // 用户输入的数字等于两个数字的和，执行删除操作
        this.$http.get("/da/del_whitelist/" + row.id).then((response) => {
          location.reload();
        });
      } else {
        this.$message.error("数字不正确,验证失败，再次提醒请谨慎操作!");
      }
    })
    .catch(() => {
      // 用户点击取消按钮或关闭对话框
    });
}


    },


    data() {
      return {
        tableData: [],
        sum: "",
        numberA: 0,
    numberB: 0,
      }

    },
created:function(){
  //注意回调函数的作用域!!!
  this.$http.get("/da/all_whitelist").then( (response)=>  {
this.tableData = response.data
    console.log(response.data)
  })
},

mounted:function(){
 // console.log("bubbles 挂载完毕")
}

  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

  </style>
  